import { render, staticRenderFns } from "./orderBoard.vue?vue&type=template&id=5c6e4440&scoped=true"
import script from "./orderBoard.vue?vue&type=script&lang=js"
export * from "./orderBoard.vue?vue&type=script&lang=js"
import style0 from "./orderBoard.vue?vue&type=style&index=0&id=5c6e4440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e4440",
  null
  
)

export default component.exports